import * as Yup from "yup";
import dayjs from "dayjs";

// export const getValidationVerifySchema = ({ maxQty = '', enableTrackBatch = false }) => {

export const validationSchema = Yup.object({
    docItemId: Yup
        .string()
        .required("Required"),
    rackId: Yup
        .string()
        .required("Required"),
    slotId: Yup
        .string()
        .required("Required"),
    code: Yup
        .string()
        .required("Required"),
    verifyQty: Yup.lazy((val) => {

        let maxQty = val?.maxQty? val.maxQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid")
        })  

    }),
    batch: Yup.lazy((val) => {

        let enableTrackBatch = val?.enableTrackBatch? val.enableTrackBatch : 0

        let batchSchema;

        if(enableTrackBatch){
            batchSchema = Yup.object({
                expiryDate: Yup
                    .date("Invalid")
                    .required("Required")
                    .typeError("Invalid"),
                customBatchNo: Yup
                    .string()
                    .required("Required"),
            })
        }else{ // no track batch
            batchSchema = Yup.object({})
        }

        return batchSchema

    })

})

export const initialValues = {
    docItemId: "",
    itemName: "",
    rackId: "",
    slotId: "",
    code: "",
    verifyQty: {
        value: "0",
        maxQty: "0"
    },
    batch: {
        enableTrackBatch: false,
        customBatchNo: "",
        expiryDate: dayjs()
    }
}
